import { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import service from './request'

interface IAxiosGet {
  <T = unknown>(
    url: string,
    params?: Record<string, unknown>,
    config?: AxiosRequestConfig | null,
  ): Promise<CustomSuccessData<T>>
}

interface IAxiosDownload {
  (
    url: string,
    params?: Record<string, unknown>,
    config?: AxiosRequestConfig | null,
  ): Promise<AxiosResponse>
}

interface IAxiosPostOrPutOrDelete {
  <T = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): Promise<CustomSuccessData<T>>
}

interface IAxiosUpload {
  <T = unknown>(
    url: string,
    file: File,
    data?: Record<string, unknown>,
    config?: AxiosRequestConfig,
  ): Promise<CustomSuccessData<T>>
}

const get: IAxiosGet = (url, params, config) => {
  return service.get(url, { params, ...config })
}

const post: IAxiosPostOrPutOrDelete = (url, data, config) => {
  return service.post(url, data, config)
}

const put: IAxiosPostOrPutOrDelete = (url, data, config) => {
  return service.put(url, data, config)
}

const deleteRequest: IAxiosPostOrPutOrDelete = (url, data, config) => {
  return service.delete(url, { data, ...config })
}

const upload: IAxiosUpload = (url, file, data, config) => {
  const formData = new FormData()
  if (data) {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key))
        formData.append(key, data[key] as string | Blob)
    }
  }
  formData.append('file', file)

  return service.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config,
  })
}

const download: IAxiosDownload = (url, params, config) =>
  service.get(url, { params, ...config, responseType: 'arraybuffer' })

export default {
  get,
  post,
  put,
  delete: deleteRequest,
  download,
  upload,
}
